module.exports = __webpack_public_path__ + "img/sisas-logosmall.b8292425.png";